import React from 'react';

interface CheckboxButtonFormProps {
	title: string;
	titleValueMap?: { title: string, value: string }[];
    value : string;
	titleless?: boolean;
	name: string;
	editable?: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		inputStyle: string;
	};
}

export const CheckboxButtonMapForm: React.FC<CheckboxButtonFormProps> = (props: CheckboxButtonFormProps) => {

	const { 
		title,
		titleValueMap,
        value,
		titleless = false,
		name,
		editable = true,
		onChange,
		wrapperOption = {
			wrapperStyle: "w-[175px] min-w-[175px] mr-[10px] mb-[5px]",
			titleStyle: "w-[100px] min-w-[100px] text-left",
			inputStyle: "w-[75px] min-w-[75px] mr-[5px]"
		} 
	} = props;   

	return (
		<div className={`flex h-[20px] ${wrapperOption.wrapperStyle}`}>
			<p className={`${wrapperOption.titleStyle} form-title cursor-pointer mr-[5px] ${titleless ? 'hidden' : ''}`} 
				tabIndex={editable ? 0 : -1}
			>
				{title}
			</p>
			{titleValueMap && titleValueMap.map((mapItem, mapIndex) => (
				<div key={mapItem.value} className={`flex ${wrapperOption.inputStyle}`}>
					<div 
						className={`flex w-[75px] items-center border border-gray-300 rounded-[4px] pl-[5px]
								${editable ? '' : 'bg-gray-100'}
							`}
						onClick={() => {
							if(!editable) return;
							onChange({ target: { name, value: mapItem.value } } as React.ChangeEvent<HTMLInputElement>);
						}} // onClick 이벤트는 여기에
					>
						<input 
							id={`${name}-${mapItem.value}`}
							type="checkbox" 
							value={mapItem.value} 
							// onChange={onChange} << 설정하면 안된다.
							name={name} 
							className=""
							checked={mapItem.value === value}
							disabled={!editable}
						/>
						<label htmlFor={`${name}-${mapItem.value}`} className="pl-[5px]">{mapItem.title}</label>
					</div>
				</div>
			))}
		</div>
	)
}